import { createValueFormatter } from '@cmg/data-grid';
import isEmpty from 'lodash/isEmpty';
import isNil from 'lodash/isNil';

import type {
  CalendarGridColDef,
  CalendarGridRowData,
  CalendarGridValueGetterFunc,
} from '../../CalendarGrid.model';
import { getArrayValueTooltipContent } from '../../CalendarGrid.model';

export type Value = string[];

export const valueGetter: CalendarGridValueGetterFunc<Value> = ({ data }) => {
  return (
    data?.offeringNotes?.map(record => record?.note).filter((note): note is string => !!note) ??
    null
  );
};

export const valueFormatter = createValueFormatter<CalendarGridRowData, Value>({
  gridRow: ({ value }) => {
    return isEmpty(value) || isNil(value) ? '-' : value.join(', ');
  },
});

const offeringNotesColDef: CalendarGridColDef<Value> = {
  colId: 'offeringNotes',
  headerName: 'Offering Notes',
  width: 180,
  type: 'text',
  filter: 'agTextColumnFilter',
  valueGetter,
  valueFormatter,
  tooltipField: 'offeringNotes',
  tooltipComponentParams: {
    getContent: getArrayValueTooltipContent,
  },
};

export default offeringNotesColDef;
